import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from "prop-types";

const SwiperCard = (props) => {
  const { card, wrapperStart, wrapperEnd, enabled } = props;
  const swiper = React.useRef();

  return (
    <Swiper
      enabled={enabled}
      style={{ width: "100%" }}
      spaceBetween={0}
      initialSlide={Boolean(wrapperStart) ? 1 : 0}
      //resistanceRatio={0}
      slideToClickedSlide={true}
      ref={swiper}
    >
      {wrapperStart && (
        <SwiperSlide
          slot="wrapper-start"
          onClick={() => {
            swiper.current.swiper.slideNext();
          }}
          style={{
            justifyContent: "center",
            height: "auto",
          }}
        >
          {wrapperStart}
        </SwiperSlide>
      )}

      <SwiperSlide slot="slide-0">{card}</SwiperSlide>

      {wrapperEnd && (
        <SwiperSlide
          slot="wrapper-end"
          onClick={() => {
            swiper.current.swiper.slidePrev();
          }}
          style={{
            justifyContent: "center",
            height: "auto",
          }}
        >
          {wrapperEnd}
        </SwiperSlide>
      )}
    </Swiper>
  );
};
SwiperCard.propTypes = {
  card: PropTypes.element.isRequired,
  wrapperStart: PropTypes.element,
  wrapperEnd: PropTypes.element,
  enabled: PropTypes.bool,
};
export default SwiperCard;
